import axios from 'axios';
import '../../common/axiosInterceptor/axios-interceptor';

const BASE = `${process.env.REACT_APP_API_BASE_URL}/admindashboard/api`;

export const getMachineHealthAPI = (machineUDI) => axios({
  method: 'get',
  url: `${BASE}/getMachineHealth`,
  params: { machineUDI },
  authRequired: true,
});

export const getMachineHealthHistoryAPI = (machineUDI, { from, to, interval, board } = {}) => axios({
  method: 'get',
  url: `${BASE}/getMachineHealthHistory`,
  params: {
    machineUDI,
    ...(from ? { from } : {}),
    ...(to ? { to } : {}),
    ...(interval ? { interval } : {}),
    ...(board ? { board } : {}),
  },
  authRequired: true,
});

export const getMachineHealthAlertsAPI = (machineUDI, { from, to, board } = {}) => axios({
  method: 'get',
  url: `${BASE}/getMachineHealthAlerts`,
  params: {
    machineUDI,
    ...(from ? { from } : {}),
    ...(to ? { to } : {}),
    ...(board ? { board } : {}),
  },
  authRequired: true,
});
